import { STATIC_LOGO_CARD_ENRICHMENT } from '../../../../shared/constants';

/**
 * The static logo card static impression enrichment
 */
export const STATIC_ENRICHMENT = {
    ...STATIC_LOGO_CARD_ENRICHMENT,
    type: 'logo_card_is_shown',
    feature: { name: 'logo_maker' },
};
